/**
 * <ImportStudent 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import classnames from 'classnames'
import papaparse from 'papaparse';
import downloadjs from 'downloadjs';
import {startsWith, difference} from 'lodash';

import Steps from 'components/UI/Steps';
import './ImportStudent.scss';
import Loading from 'components/UI/Loading';
import Transition from 'components/UI/Transition';
import Dropzone from 'react-dropzone';

import basicInfoFields from 'containers/pages/StudentSettings/basicInfoFields';
import locale from './locale';
import alert from 'util/alert';

import createBulkStudent from 'controllers/student/createBulkStudent';
import getStudentCustomFields from 'controllers/student/getStudentCustomFields';
import CSVTemplate from './csvTemplate';

import {
	PanelWrapper,
} from 'components/UI'

const ACCEPT_MIME = 'text/csv';
const MAX_SIZE = 5 * 1000 * 1000;
const MIN_SIZE = 0;

const DEFAULT_SEP = ';';


// The every field must be submitted to the controller
// so we must add these empty fields
const EMPTY_STUDENT = {
	ssFirstName: '', 
	ssLastName: '', 
	ssNickName: '', 
	ssGender: 3, 
  ssBirthday: null, 
  ssPhone: '', 
  ssHomePhone: '', 
  ssEmail: '', 
  ssSource: '', 
  ssSocialType: 0, 
  ssSocialID: '', 
  ssCountry: '', 
  ssProvince: '', 
  ssCity: '', 
  ssPostcode: '', 
  ssAddress: '', 
  ssRemark: '', 
  ssStudentCreateTime: null, 
  ssSuitNumber: '', 
  ssCode: '', 
  ssSchool: '', 
  ssStudent: '', 

  custom_data: {},

  ssParentsName: '', 
  ssGuardianRelation: '', 
  ssParentsEmail: '', 
  ssParentsPhone: '', 

  ssParents2Name: '', 
  ssGuardian2Relation: '', 
  ssParents2Email: '', 
  ssParents2Phone: '', 
}

const STUDENT_TO_SERVER = {
  firstName: 'ssFirstName',
	lastName: 'ssLastName',
	nickName: 'ssNickName',
	gender: 'ssGender',
  dob: 'ssBirthday',
  countryCode: 'ssPhone',
  phone: 'ssPhone',
  email: 'ssEmail',
  country: 'ssCountry',
  province: 'ssProvince',
  city: 'ssCity',
  postalCode: 'ssPostcode',
  address: 'ssAddress',
  remark: 'ssRemark',
  suiteNumber: 'ssSuitNumber',
  customDate: 'custom_data',
  primaryGuardianName: 'ssParentsName',
  primaryGuardianRelationship: 'ssGuardianRelation',
  primaryGuardianEmail: 'ssParentsEmail',
  primaryGuardianPhone: 'ssParentsPhone',
  secondaryGuardianName: 'ssParents2Name',
  secondaryGuardianRelationship: 'ssGuardian2Relation',
  secondaryGuardianEmail: 'ssParents2Email',
  secondaryGuardianPhone: 'ssParents2Phone',
}
const COUNTRY_CODE = ['1', '961', '61', '65'];
const GENDER = ['M','F','N/A']
const mapStateToProps = state => ({
  subscription: state.gSubscription,
  user: state.user
});

class ImportStudent extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.state = {
      activeStep: 0,
      totalStep: 0,
      fetching: true,
      customFields: [],
      file: undefined,
      importedDataLabels:[],
      selectedOption: [],
      fieldColumns:[],
      currentBasicMappingStep: 0,
      currentCustomMappingStep:0,
      students: [],
      hasCustomFields: false
    }

    this.needToUpdateCustomField = false;

    this.goToNextStage = this.goToNextStage.bind(this);
    this.goToPreviousStage = this.goToPreviousStage.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onImport = this.onImport.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.processCSVData = this.processCSVData.bind(this);
    this.getFields = this.getFields.bind(this);
    this.execCreateBulkStudent = this.execCreateBulkStudent.bind(this);
    this.note = [
      __("Follow the CSV template provided below", locale),
      __("If you would like to import students with customized data fields, please set it up at 'Administration'-->'Students'-->'Student Custom Fields'", locale),
      __("Date has to be in format of 'YYYY-MM-DD'", locale),
      __("Gender has to be either letter 'M' or 'F' or 'N/A'", locale),
      __("Email has to be in format of 'xxxx@xxx.xxx'", locale),
      __("Phone number is consisted with a Country code following by the phone number (numbers only, no space or other characters)", locale),
      __("Value of the 'select' (single choice) custom field has to be only one of its choices", locale),
      __("Value of the 'checkbox' (multiple choice) custom field has to be one or more of its choices, seperated by comma. For example: 'english, math, science'", locale),
    ]
  }

  componentWillMount() {
    this.fetchSetting();
  }

  fetchSetting() {
    const schoolId = localStorage.getItem('schoolId');
    getStudentCustomFields(schoolId)
      .then(({student_fields_setting})=>{
        this.student_fields_setting= {};
        if(student_fields_setting && student_fields_setting.fields.length>0){
          this.student_fields_setting = student_fields_setting;
          this.setState({
            hasCustomFields: true
          }, ()=>{
            this.getFields();
          })
        }else {
          this.getFields();
        }
        this.setState({
          fetching: false,
        });
      }); 
  }

  removeFile() {
    this.setState({
      file: undefined,
      activeStep:0,
      currentBasicMappingStep: 0,
      currentCustomMappingStep: 0
    });
  }

  goToNextStage() {
    this.setState({
      activeStep: this.state.activeStep + 1,
    });
  }
  goToPreviousStage(stage) {
    const { students, basicFields, fieldColumns, currentBasicMappingStep, currentCustomMappingStep, customFields, } = this.state;
    let columns = fieldColumns;

    if(stage === 'basic'){
      let toServerAttribute = STUDENT_TO_SERVER[basicFields[currentBasicMappingStep].name];    
      students.map((student)=>{
        student[toServerAttribute] = ''
      })
      if(basicFields[currentBasicMappingStep].mappedColumnIndex !== null) {
        columns[basicFields[currentBasicMappingStep].mappedColumnIndex].mappedfield = {};     
      }
    }else{
      students.map((student)=>{
        student['custom_data'][customFields[currentCustomMappingStep].id]=''
      })
      if(customFields[currentCustomMappingStep].mappedColumnIndex) {
        columns[customFields[currentCustomMappingStep].mappedColumnIndex].mappedfield = {};      
      }
    }
    this.setState({
      activeStep: stage==='basic'? 1: 2,
      fieldColumns: columns
    });
  }
  onDrop(accept, reject) {
    if (reject.length > 0) {
      // TODO:
    } else if (accept.length > 0) {
      this.setState({
        file: accept[0],
      },()=>{
        this.onImport();        
      });
    }
  }

  execCreateBulkStudent() {
    const { students } = this.state;
    const {subscription} = this.props;
    const {saas_version, maximum_amount, existing_amount, is_valid} = subscription.result;
    const {maximum_student} = maximum_amount;
    const {student_amount} = existing_amount;

    const schoolId = localStorage.getItem('schoolId');

    if(is_valid && (saas_version === 1 || maximum_student === null || ((student_amount+students.length)<= maximum_student))){
      const studentsToServer = students.map((student)=>{
        if(Object.keys(student.custom_data).length>0){
          Object.keys(student.custom_data).forEach((key)=>{
            if(student.custom_data[key]===''){
              delete student.custom_data[key];
            }
          })
        }
        return student;
      })
      createBulkStudent(schoolId, students)
        .then(({result})=>{
          this.setState({
            fetching: false,
          });
          if (result === 'success') {
            browserHistory.push('/student');
          } else {
            alert.fail(__('Failed to import', locale, { num: studentArr.length }), __('Import Failed', locale))
          }
        });
    }else {
      alert.message(__('You are about go over the student limit, please upgrade to higher subscription plan to add more students', 'header'), __('Upgrade Subscription Plan', 'header'))
    }
  }

  getFields() {
    let basicFields = [];
    let customFields = [];
    let tableFields = [];
    let tableTheads = [];
    const { hasCustomFields } = this.state;
    basicInfoFields.map(({ name, label, required, isImportField })=>{
      if (isImportField && name!=='countryCode') {
        basicFields.push({ name, label, required, mappedColumnIndex: null });
        this.setState({selectedOption: [...this.state.selectedOption, null]});
      }
    });
    if(hasCustomFields){
      this.student_fields_setting.fields.map((field)=>{
        const { id, label, required } = field;
        customFields.push({ ...field, name: id });
        tableTheads.push({ label, required });
        tableFields.push(id);
      });
    }
    this.setState({
      basicFields,
      customFields,
      tableTheads,
      tableFields
    });
  }

  onImport() {
    const { file } = this.state;

    this.setState({
      fetching: true,
    });
    papaparse.parse(file, {
      complete: ({ data, errors, meta })=>{
        if (errors.length > 0) {
          this.setState({
            fetching: false,
          });
          // TODO:
        } else {
          if(data.length>0){
          let fieldColumns = [];
          let formatedLabels = data[0].map((item, index)=>{
            return {value: index, label: item}
          })
          this.setState({importedDataLabels: formatedLabels})
          let rowValues = data.slice(1);
          formatedLabels.map(({value, label})=>{
            let column = [];
            rowValues.map((row)=>{
              column.push(row[value])
            })
            fieldColumns.push({name:label, value:column, mappedfield:{}});
          })
          this.setState({fieldColumns})
          }
          this.processCSVData(data)
        }
        this.setState({fetching: false})
        this.goToNextStage();
      }
    });
  }

  processCSVData(data = []) {
    const { customFields } = this.state;
    let students = [];

    data.slice(1).map((row, realIdx)=>{
      let customData = {};
      customFields.map(({id})=>{
        customData[id] = ''
      })
      let emptyStudent = {...EMPTY_STUDENT, custom_data: customData}
      students.push(emptyStudent);
    });
    this.setState({students})
  }

  nextBasicStep() {
    const { currentBasicMappingStep, basicFields, hasCustomFields } = this.state;
    if(currentBasicMappingStep == basicFields.length-1){
      if(hasCustomFields){
        this.goToNextStage();
      }else {
        this.setState({
          activeStep: this.state.activeStep + 2,
        });
      }
    }else {
      this.setState({currentBasicMappingStep: currentBasicMappingStep+1});            
    }
  }
  previousBasicStep(){
    const { students, basicFields, fieldColumns, currentBasicMappingStep } = this.state;

    let toServerAttribute = STUDENT_TO_SERVER[basicFields[currentBasicMappingStep-1].name];    
    students.map((student)=>{
      student[toServerAttribute] = ''
    })
    let columns = fieldColumns;
    if(basicFields[currentBasicMappingStep-1].mappedColumnIndex !== null) {
      columns[basicFields[currentBasicMappingStep-1].mappedColumnIndex].mappedfield = {};     
    }
    this.setState({currentBasicMappingStep: currentBasicMappingStep-1, fieldColumns: columns});
  }
  nextCustomStep() {
    const { currentCustomMappingStep, customFields } = this.state;    
    if(currentCustomMappingStep == customFields.length-1){
      this.goToNextStage();
    }else{
      this.setState({currentCustomMappingStep: currentCustomMappingStep+1})            
    }
  }
  previousCustomStep(){
    const { students, currentCustomMappingStep, customFields, fieldColumns } = this.state;    
    students.map((student)=>{
      student['custom_data'][customFields[currentCustomMappingStep-1].id]=''
    })
    let columns = fieldColumns;
    if(customFields[currentCustomMappingStep-1].mappedColumnIndex) {
      columns[customFields[currentCustomMappingStep-1].mappedColumnIndex].mappedfield = {};      
    }
    this.setState({currentCustomMappingStep: currentCustomMappingStep-1, fieldColumns: columns})
  }

  validatePhoneNumber(number) {
    let validateResult = COUNTRY_CODE.map((code)=>{
      let isValidPhone=false;      
      if(startsWith(number, code)){
        isValidPhone=true;
      }
      return isValidPhone;      
    })
    return validateResult.includes(true);
  }
  validateBasicInputs(column){
    const { basicFields, currentBasicMappingStep } = this.state;
    let isValid = true;    
    if(basicFields[currentBasicMappingStep].required) {
      column.value.forEach((value)=>{
        if(value.length<1){
          isValid=false;
        }
      });
      if(!isValid) {
        return {result: isValid, error: __('Required column contains empty fields', locale)};                        
      }
    }
    switch(basicFields[currentBasicMappingStep].name) {
      case 'gender':
        if(column.value.length>0){
          column.value.forEach((value)=>{
            if(!GENDER.includes(value)){
              isValid = false;
            }
          });
        }
        return {result: isValid, error: !isValid? __('Gender must be M, F or N/A', locale): ''};
      case 'phone': 
      case 'primaryGuardianPhone':
      case 'secondaryGuardianPhone':
        let phoneReg = /^\d+$/;
        column.value.forEach((value)=>{
          if((!this.validatePhoneNumber(value) || !phoneReg.test(value)) && value.length>5){
            isValid=false;
          }
        });
        return {result: isValid, error: !isValid? __('Contains invalid phone numbers (A country code followed by phone number, numbers only, no space or other characters)', locale):''};
      case 'dob':
        let dobReg = /(\d{4})-(\d{2})-(\d{2})/;
        column.value.forEach((value)=>{
          if(!dobReg.test(value) && value.length>0){
            isValid=false
          }
        })
        return {result: isValid, error: !isValid? __("Contains invalid date format (it has to be in format of 'YYYY-MM-DD')", locale):''};      
      case 'email':
      case 'primaryGuardianEmail':
      case 'secondaryGuardianEmail':
        let emailReg = /\S+@\S+\.\S+/;  
        column.value.forEach((value)=>{
          if(!emailReg.test(value) && value.length>0){
            isValid=false
          }
        })
        return {result: isValid, error: !isValid? __("Contains invalid email format (it has to be in format of 'xxxx@xxx.xxx')", locale):''};    
      default:
        return {result: true, error: ''}
        
    }
  }
  validateCustomInputs(column) {
    const {customFields, currentCustomMappingStep } = this.state;
    let isValid = true;    
    if(customFields[currentCustomMappingStep].required) {
      column.value.forEach((value)=>{
        if(value.length<1){
          isValid=false;
        }
      });
      if(!isValid) {
        return {result: isValid, error: __('Required column contains empty fields', locale)};                        
      }
    }
    switch(customFields[currentCustomMappingStep].type) {
      case 'select':
        column.value.forEach((value)=>{
          let trimedValue = value.trim();
          if(!customFields[currentCustomMappingStep].options.includes(trimedValue) && trimedValue.length>0){
            isValid=false
          }
        })
        return {result: isValid, error: !isValid? __("Contains invalid selection options", locale):''};            
      case 'checkbox':
        column.value.forEach((value)=>{
          if(difference(value.split(',').map(item=>item.trim()), customFields[currentCustomMappingStep].options).length>=value.split(',').length && value.length>0){
            isValid=false
          }
        })
        return {result: isValid, error: !isValid? __("Contains invalid checkbox options", locale):''};      
      default:
        return {result: true, error: ''}  
    }
  }
  mapColumn(column, index) {
    const { students, basicFields, customFields, fieldColumns, currentBasicMappingStep, currentCustomMappingStep, activeStep, hasCustomFields } = this.state;
    let validation;
    if(activeStep === 1) {
      let toServerAttribute = STUDENT_TO_SERVER[basicFields[currentBasicMappingStep].name];   
      validation = this.validateBasicInputs(column);
      if(validation.result == true){
        students.map((student, index)=>{
          if(basicFields[currentBasicMappingStep].name === 'gender'){
            if(column.value[index] === 'M'){
              student[toServerAttribute] = 0
            }else if(column.value[index] === 'F') {
              student[toServerAttribute] = 1
            }else {
              student[toServerAttribute] = 3
            }
          }else if(basicFields[currentBasicMappingStep].name === 'dob' && column.value[index].length===0){
            student[toServerAttribute] = null;
          }else{
            student[toServerAttribute] = column.value[index];            
          }
        })
        let columns = fieldColumns;
        columns[index].selected = true;
        columns[index].mappedfield = basicFields[currentBasicMappingStep];
        let fields = basicFields;
        fields[currentBasicMappingStep].mappedColumnIndex = index;
        if(currentBasicMappingStep==basicFields.length-1){
          this.setState({fieldColumns: columns, basicFields: fields});
          if(hasCustomFields){
            this.goToNextStage();
          }else {
            this.setState({
              activeStep: this.state.activeStep + 2,
            });
          }    
        }else{
          this.setState({currentBasicMappingStep: currentBasicMappingStep+1, fieldColumns: columns, basicFields: fields});
        }
      }else {
        alert.fail(__(validation.error, locale))                            
      }
    }else if (activeStep === 2) {
      validation = this.validateCustomInputs(column);
      if(validation.result == true) {
        students.map((student, index)=>{
          let customFieldId= customFields[currentCustomMappingStep].id;
          if(customFields[currentCustomMappingStep].type === 'checkbox'){
            student['custom_data'][customFieldId] = JSON.stringify(column.value[index].replace(/ *, */g, ",").split(','));
          }else {
            student['custom_data'][customFieldId] = column.value[index];            
          }
        })
        let columns = fieldColumns;
        columns[index].selected = true;
        columns[index].mappedfield = customFields[currentCustomMappingStep];
        let fields = customFields;
        fields[currentCustomMappingStep].mappedColumnIndex = index;
        if(currentCustomMappingStep==customFields.length-1){
          this.setState({fieldColumns: columns, customFields: fields});
          this.goToNextStage();         
        }else{
          this.setState({currentCustomMappingStep: currentCustomMappingStep+1, fieldColumns: columns, customFields: fields});          
        }
      }else {
        alert.fail(__(validation.error, locale))                                    
      }
    }
  }
  renderColumnPicker() {
    const { fieldColumns } = this.state;
    return (
      fieldColumns.map((column, index)=>{
        return (
          <div className="col-sm-4 columnPicker">
            <h4 className='colunmHeader'>{__('Column', locale)} {index+1}</h4>
            <table style={{height: 220}}>
              <tr>
                <th style={{width: '20%' }}></th>
                <th style={{width: '80%' }}>{column.name}</th>
              </tr>
              {column.value.map((value, i)=>{
                if(i<5){
                  return(
                    <tr>
                      <td>{i+1}</td>
                      <td className='columValue'>{value}</td>
                    </tr>
                  )
                }
                return;
              })}
            </table>
            { column.value.length>5 &&
                <div className='moreRowsText'>{__('{number} more rows', locale, {number: column.value.length - 5})}</div>
              }
              <div className='mappedField'>
                {
                Object.keys(column.mappedfield).length===0 && 
                <button className="btn" onClick={()=>this.mapColumn(column, index)}>{__('Select this column', locale)}</button>
              }
              {
                Object.keys(column.mappedfield).length>0 && 
                <p>{__('Mapped as', locale)} {column.mappedfield.label} </p>
              }
              </div>
          </div>
        )
      })
    )
  }
  renderMappingDescription(){
    const { activeStep, currentBasicMappingStep, basicFields, customFields, currentCustomMappingStep, hasCustomFields } = this.state;
    if(activeStep === 1) {
      return (
        <div>
          <div className='row'>
            <div className='col-sm-9 sectionHeader'>
              {__('Basic Fields Mapping', locale)}
            </div>
          </div>
          <div className='progressWrapper'>
            {__('Step {currentStep} of {totalStep}:', locale, {currentStep: currentBasicMappingStep+1, totalStep: basicFields.length, label: basicFields[currentBasicMappingStep].label} )}
            <h2>{__('{label}', locale, {currentStep: currentBasicMappingStep+1, totalStep: basicFields.length, label: basicFields[currentBasicMappingStep].label} )}</h2>
            {__('Which column contains the {label} of your students?', locale, {currentStep: currentBasicMappingStep+1, totalStep: basicFields.length, label: basicFields[currentBasicMappingStep].label} )}
          </div>
          <div className='mappingButtons'>
              {
                currentBasicMappingStep>0 && 
                <button type='button' className='btn previousBtn' onClick={()=>this.previousBasicStep()}>{__('Previous step', locale)}</button>
              }
              { currentBasicMappingStep < basicFields.length &&
                <button type='button' className='btn btn-primary nextBtn' onClick={()=>this.nextBasicStep()} disabled={basicFields[currentBasicMappingStep].required}>{__('Skip this step', locale)}</button>
              }
            </div>
        </div>
      )
    }else if (activeStep === 2 && customFields.length>0) {
      return (
        <div>
          <div className='row'>
            <div className='col-sm-9 sectionHeader'>
              {__('Custom Fields Mapping', locale)}
            </div>
          </div>
          <div className='progressWrapper'>
            {__('Step {currentStep} of {totalStep}: ', locale, {currentStep: currentCustomMappingStep+1, totalStep: customFields.length, label: customFields[currentCustomMappingStep].label})}
            <h3>{__(customFields[currentCustomMappingStep].label, locale)}</h3>
            {__('Which column contains the {label} of your students?', locale, {currentStep: currentCustomMappingStep+1, totalStep: customFields.length, label: customFields[currentCustomMappingStep].label})}
          </div>
         
          {customFields[currentCustomMappingStep].type !== 'text' && 
            <div>{__('Options', locale)}: {customFields[currentCustomMappingStep].options.toString()}</div>
          }
          <div className='mappingButtons'>
              {
                <button type='button' className='btn previousBtn' onClick={()=>{
                  if(currentCustomMappingStep === 0){
                    this.goToPreviousStage('basic');
                  }else{
                    this.previousCustomStep();
                  }
                }}>{currentCustomMappingStep === 0? __('Back to Basic Fields', locale): __('Previous step', locale)}</button>
              }
              { currentCustomMappingStep < customFields.length &&
                <button type='button' className='btn btn-primary nextBtn' onClick={()=>this.nextCustomStep()} disabled={customFields[currentCustomMappingStep].required}>{__('Skip this step', locale)}</button>
              }
          </div>
        </div>
      )
    }else {
      return null;
    }
  }
  render() {

    const { 
      activeStep, 
      fetching,
      file,
      fieldColumns,
      hasCustomFields
    } = this.state;

    const steps = [
      {
        label: __('Upload CSV', locale),
      },
      {
        label: __('Map Basic Fields', locale),
      },
      {
        label: __('Map Custom Fields', locale),
      },
      {
        label: __('Import', locale),
      },
    ];

    return (
      <PanelWrapper className='ImportStudent'>
        { fetching && <Loading /> }
        { fetching !== true && 
        <Transition>
        <div className='ImportStudentContent'>
          <div className='BreadCrumbs'>
            <Steps steps={steps} activeStep={activeStep} />
          </div>
          {activeStep === 0 && 
            <div>
              <h1>{__('Student Imports', locale)}</h1>
              <div className='importTitle'>{__("Modify your CSV file with our CSV template to help you import students at once", locale)}</div>
              <div  className={classnames('col-sm-8 Instruction', { hasButton: activeStep === 1})}>
                <p>{__('Student Import Rules', locale)}: </p>
                {this.note.map((note, key)=>{
                  return <p key={key}>{key+1}. {__(note, locale)}</p>
                })}
              </div>
            </div>
          }
          <div className='row'>
          <div className='Step-0'>
            { !file && 
                <div className='UploadZone'>
                  <CSVTemplate customFields={this.student_fields_setting} />
                  <Dropzone 
                    accept={ACCEPT_MIME}
                    multiple={false}
                    className='zone'
                    maxSize={MAX_SIZE}
                    minSize={MIN_SIZE}
                    onDrop={this.onDrop}
                    children={(
                      <div className='UploadZoneContent'>
                        <h2>{__('Drag and drop your CSV file here', locale)}</h2>
                        <a>{__('Or select a file from your computer...', locale)}</a>
                      </div>  
                    )}
                  /> 
                </div>
                }
          </div>
          <div className='Step-1 col-sm-4'>
              { file &&
              <div>
                <div className='file'><i className='fa icon-doc-text-text-o'></i> {file.name} <span className='deleteIconWrapper' onClick={this.removeFile}><i className='fa icon-cancel deleteIcon'></i></span></div>
                <div className='mappingSteps'>
                  {this.renderMappingDescription()}
                </div>
              </div>
              }
              {
              activeStep === 3 &&
              <div className='mappingSteps'>
                <div className='row'>
                  <div className='col-sm-9 sectionHeader'>
                    {__('Ready to Import', locale)}
                    <div className='mappingButtons'>
                      <button className='btn' onClick={()=> hasCustomFields? this.goToPreviousStage('custom'): this.goToPreviousStage('basic')}>{hasCustomFields? __('Back to Custom Fields', locale) : __('Back to Basic Fields', locale)}</button>
                      <button className='btn btn-primary' onClick={()=>this.execCreateBulkStudent()}>{__('Import', locale)}</button>
                    </div>
                  </div>
                  
                </div>
              </div>
            }
            </div>
            { (file && fieldColumns) && 
              <div className='col-sm-8' style={{paddingLeft: 10, paddingRight: 10}}>
                {this.renderColumnPicker()}
              </div>
            }
          </div>
         </div> 
        </Transition> }
      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps, {})(ImportStudent);



// WEBPACK FOOTER //
// ./src/containers/pages/ImportStudent/index.js